(function () {
  'use strict';

  var swiperWrapperIdSeed = 0;
  var roleButtonKeyboardBound = false;

  function setAttrs(element, attrs) {
    if (!element) return;

    Object.keys(attrs).forEach(function (key) {
      if (attrs[key] === null || attrs[key] === undefined) return;
      var value = String(attrs[key]);
      if (element.getAttribute(key) !== value) {
        element.setAttribute(key, value);
      }
    });
  }

  function textContent(element) {
    if (!element) return '';
    return (element.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function isVisible(element) {
    if (!element) return false;
    if (element.hidden) return false;
    if (!window.getComputedStyle) return true;

    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function hasFocusableDescendant(element) {
    if (!element || !element.querySelector) return false;
    return Boolean(
      element.querySelector('a[href], button, input, select, textarea, summary, [tabindex]:not([tabindex="-1"])')
    );
  }

  function applyToAll(selector, callback) {
    var elements = document.querySelectorAll(selector);
    for (var i = 0; i < elements.length; i++) {
      callback(elements[i], i);
    }
  }

  function ensureHeadingSemantics(element, level) {
    if (!element) return;
    var tag = element.tagName ? element.tagName.toLowerCase() : '';
    if (/^h[1-6]$/.test(tag)) return;
    setAttrs(element, {
      role: 'heading',
      'aria-level': level,
      'data-acsb-fake-title': 'true'
    });
  }

  function ensureWrapperId(wrapper) {
    if (!wrapper) return '';
    if (!wrapper.id) {
      swiperWrapperIdSeed += 1;
      wrapper.id = 'swiper-wrapper-a11y-' + swiperWrapperIdSeed;
    }
    return wrapper.id;
  }

  function normalizeNavigationLandmarks() {
    applyToAll('section#shopify-pc__banner .shopify-pc__banner__wrapper', function (element) {
      setAttrs(element, {
        role: 'navigation',
        'aria-label': 'Inner Menu'
      });
    });

    applyToAll('header.Header', function (element) {
      setAttrs(element, {
        role: 'navigation',
        'aria-label': 'Main Menu'
      });
    });

    applyToAll('.pc-option-list', function (element) {
      setAttrs(element, {
        role: 'navigation',
        'aria-label': 'Main Menu'
      });
    });

    applyToAll('footer .logo.flex_inner.flex60', function (element) {
      setAttrs(element, {
        role: 'navigation',
        'aria-label': 'Footer Menu'
      });
    });

    applyToAll('footer .footer_flex.flex40', function (element) {
      setAttrs(element, {
        role: 'navigation',
        'aria-label': 'Footer Menu'
      });
    });

    applyToAll('footer .footer-block.footer-block--menu', function (element) {
      var heading = textContent(element.querySelector('.footer-block__heading'));
      setAttrs(element, {
        role: 'navigation',
        'aria-label': heading || 'Footer Menu'
      });
    });
  }

  function normalizeCarousels() {
    var regionSelectors = [
      '#announcement-bar-with-slider',
      '.main-video.main-video-wrap.swiper-container',
      '.slide-collection.swiper-container',
      '.swiper-container.review_slide'
    ];

    applyToAll(regionSelectors.join(','), function (element) {
      setAttrs(element, {
        role: 'region',
        'aria-label': 'Carousel',
        'data-acsb-overflower': 'true',
        'data-acsb-carousel': 'true',
        'data-acsb-force-visible': 'true'
      });
    });

    applyToAll('.pc-slide-icon.slide-icon.swiper-container', function (element) {
      setAttrs(element, {
        role: 'navigation',
        'aria-label': 'Carousel',
        'data-acsb-carousel': 'true',
        'data-acsb-force-visible': 'true'
      });
    });
  }

  function normalizeSwiperControls() {
    var buttonGroups = [
      {
        selector: '.main-video .main-next, .slide-collection .next-btn, .review-next, .logo-next',
        label: 'Next slide'
      },
      {
        selector: '.main-video .main-prev, .slide-collection .prev-btn, .review-prev, .logo-prev',
        label: 'Previous slide'
      }
    ];

    for (var i = 0; i < buttonGroups.length; i++) {
      applyToAll(buttonGroups[i].selector, function (element) {
        var wrapper = element.closest('.swiper-container');
        var wrapperId = '';

        if (wrapper) {
          wrapperId = ensureWrapperId(wrapper.querySelector('.swiper-wrapper'));
        }

        setAttrs(element, {
          role: 'button',
          tabindex: '0',
          'aria-label': buttonGroups[i].label,
          'aria-disabled': String(
            element.classList.contains('swiper-button-disabled') || element.classList.contains('swiper-button-lock')
          )
        });

        if (wrapperId) {
          setAttrs(element, { 'aria-controls': wrapperId });
        }
      });
    }
  }

  function normalizePseudoButtons() {
    var selectors = [
      { selector: '.plybtn', label: 'Enlarge' },
      { selector: '.open_pop', label: 'Close' },
      { selector: '.banner_notice', label: 'Open banner notice' },
      { selector: '.bnr_close', label: 'Close' },
      { selector: '.menu_drawer', label: 'Open menu' },
      { selector: '.download-btn', label: 'Download' }
    ];

    for (var i = 0; i < selectors.length; i++) {
      applyToAll(selectors[i].selector, function (element) {
        setAttrs(element, {
          role: 'button',
          tabindex: '0',
          'aria-label': selectors[i].label,
          'data-acsb-clickable': 'true',
          'data-acsb-navigable': 'true'
        });
      });
    }

    applyToAll('a.downloadLink', function (element) {
      setAttrs(element, {
        role: 'button',
        tabindex: '0',
        'data-acsb-clickable': 'true',
        'data-acsb-navigable': 'true',
        'data-acsb-now-navigable': 'true',
        'data-custom-button-processed': 'true'
      });
    });
  }

  function normalizeSearchLandmarks() {
    applyToAll('form.search.search-modal__form, main-search form.search', function (element) {
      setAttrs(element, { role: 'search' });
    });
  }

  function normalizeLinks() {
    applyToAll('a.header__heading-link[href="/"]', function (element) {
      if (!element.hasAttribute('aria-label')) {
        setAttrs(element, { 'aria-label': 'Redirects to homepage' });
      }
    });

    applyToAll('.list-social__link', function (element) {
      if (element.hasAttribute('aria-label')) return;
      var hiddenLabel = textContent(element.querySelector('.visually-hidden'));
      if (hiddenLabel) {
        setAttrs(element, { 'aria-label': hiddenLabel });
      }
    });

    applyToAll('a[target="_blank"]', function (element) {
      var relTokens = (element.getAttribute('rel') || '')
        .toLowerCase()
        .split(/\s+/)
        .filter(Boolean);

      if (relTokens.indexOf('noopener') === -1) {
        relTokens.push('noopener');
      }
      if (relTokens.indexOf('noreferrer') === -1) {
        relTokens.push('noreferrer');
      }
      setAttrs(element, { rel: relTokens.join(' ') });

      var hasWindowNotice =
        element.querySelector('.a11y-new-window-note') ||
        element.querySelector('[data-acsb-sr-only="true"]') ||
        element.querySelector('.acsb-sr-only');

      if (!hasWindowNotice) {
        var note = document.createElement('span');
        note.className = 'visually-hidden a11y-new-window-note';
        note.textContent = ' (opens in a new window)';
        element.appendChild(note);
      }
    });
  }

  function inferInputLabel(input) {
    if (!input) return '';
    var labelText = '';

    if (input.placeholder) {
      labelText = textContent({ textContent: input.placeholder });
    }

    if (!labelText && input.id) {
      var labels = document.querySelectorAll('label[for]');
      for (var i = 0; i < labels.length; i++) {
        if (labels[i].getAttribute('for') === input.id) {
          labelText = textContent(labels[i]);
          break;
        }
      }
    }

    if (!labelText) {
      var fieldLabel = input.closest('label, .field, .facets__label, .mobile-facets__label');
      labelText = textContent(fieldLabel);
    }

    return labelText;
  }

  function normalizeFormFields() {
    applyToAll('input[type="email"], input[type="search"], input[type="number"]', function (input) {
      if (input.required) {
        setAttrs(input, { 'aria-required': 'true' });
      }

      if (!input.hasAttribute('aria-label')) {
        var labelText = inferInputLabel(input);
        if (labelText) {
          setAttrs(input, { 'aria-label': labelText });
        }
      }
    });

    applyToAll('#FacetFiltersForm input[type="checkbox"], #FacetFiltersFormMobile input[type="checkbox"]', function (input) {
      if (input.hasAttribute('aria-label')) return;
      var labelText = inferInputLabel(input);
      if (labelText) {
        setAttrs(input, { 'aria-label': labelText });
      }
    });
  }

  function listHasAccessibleItems(list) {
    if (!list || !list.children || !list.children.length) return false;

    for (var i = 0; i < list.children.length; i++) {
      var child = list.children[i];
      if (!child || !child.tagName || child.tagName.toLowerCase() !== 'li') continue;
      if (!isVisible(child)) continue;
      if (child.getAttribute('aria-hidden') === 'true') continue;

      if (textContent(child)) return true;
      if (child.querySelector('li')) return true;
      if (child.querySelector('[aria-label], [aria-labelledby], img[alt], a[href], button, input, select, textarea')) {
        return true;
      }
    }

    return false;
  }

  function restoreEmptyListState(list) {
    if (!list || list.getAttribute('data-a11y-empty-list-fixed') !== 'true') return;

    var previousRole = list.getAttribute('data-a11y-empty-list-prev-role');
    var previousAriaHidden = list.getAttribute('data-a11y-empty-list-prev-aria-hidden');

    if (previousRole === '__none__') {
      list.removeAttribute('role');
    } else if (previousRole !== null) {
      list.setAttribute('role', previousRole);
    }

    if (previousAriaHidden === '__none__') {
      list.removeAttribute('aria-hidden');
    } else if (previousAriaHidden !== null) {
      list.setAttribute('aria-hidden', previousAriaHidden);
    }

    list.removeAttribute('data-a11y-empty-list-fixed');
    list.removeAttribute('data-a11y-empty-list-prev-role');
    list.removeAttribute('data-a11y-empty-list-prev-aria-hidden');
  }

  function normalizeEmptyLists() {
    applyToAll('ul, ol', function (list) {
      if (!list || !list.closest) return;
      if (list.closest('template, script, style, noscript')) return;
      if (list.getAttribute('aria-busy') === 'true') return;

      var explicitRole = (list.getAttribute('role') || '').toLowerCase();
      if (explicitRole && explicitRole !== 'list' && explicitRole !== 'none' && explicitRole !== 'presentation') {
        return;
      }

      if (listHasAccessibleItems(list)) {
        restoreEmptyListState(list);
        return;
      }

      if (list.getAttribute('data-a11y-empty-list-fixed') === 'true') return;

      list.setAttribute('data-a11y-empty-list-fixed', 'true');
      list.setAttribute('data-a11y-empty-list-prev-role', list.hasAttribute('role') ? list.getAttribute('role') : '__none__');
      list.setAttribute(
        'data-a11y-empty-list-prev-aria-hidden',
        list.hasAttribute('aria-hidden') ? list.getAttribute('aria-hidden') : '__none__'
      );
      list.setAttribute('role', 'presentation');

      if (!hasFocusableDescendant(list)) {
        list.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function normalizeHeadings() {
    var headingRules = [
      { selector: '.main-video .txt-con .tit', level: 1 },
      { selector: '.main_device .txt-slide', level: 2 },
      { selector: '.main_skincare .txt-slide', level: 2 },
      { selector: '.featured_tit', level: 3 },
      { selector: '.brandstory_wrap .txt_top', level: 2 },
      { selector: '.brandstory_wrap .video_txt > span', level: 2 },
      { selector: '.brandstory_wrap .txt_tit', level: 2 },
      { selector: '.brandstory_wrap .tech_tit', level: 2 },
      { selector: '.brandstory_wrap .com_tit', level: 2 },
      { selector: '.brandstory_wrap .sirJohn_com_desc', level: 2 },
      { selector: '.brandstory_wrap .comment.comment2 > p.fontStyle_1', level: 2 },
      { selector: '.brandstory_wrap .comment.comment3 > p.fontStyle_1', level: 2 },
      { selector: '.brandstory_wrap .eco_tit', level: 2 },
      { selector: '.brandstory_wrap .eco_flex_tit', level: 2 },
      { selector: '.brandstory_wrap .banner_tit', level: 2 },
      { selector: '.footer-block__heading.inline-richtext.flex_inner.flex60', level: 4 },
      { selector: 'footer .footer-block--menu .footer-block__heading.inline-richtext', level: 5 }
    ];

    for (var i = 0; i < headingRules.length; i++) {
      applyToAll(headingRules[i].selector, function (element) {
        ensureHeadingSemantics(element, headingRules[i].level);
      });
    }

    applyToAll('#announcement-bar-with-slider .ab-slide-text.ql-editor > h4', function (element) {
      setAttrs(element, {
        role: 'heading',
        'aria-level': '2'
      });
    });
  }

  function normalizeDecorativeElements() {
    applyToAll(
      '.icon.icon-close, .icon.icon-search, .icon.icon-caret, .icon.icon-checkmark, .spinner, .Icon',
      function (element) {
        setAttrs(element, {
          'aria-hidden': 'true',
          'data-acsb-hidden': 'true'
        });

        if (element.tagName && element.tagName.toLowerCase() === 'svg') {
          setAttrs(element, { focusable: 'false' });
        }
      }
    );

    applyToAll('.stamped-product-reviews-badge .stamped-starrating, .stamped-product-reviews-badge .stamped-fa', function (
      element
    ) {
      setAttrs(element, {
        'aria-hidden': 'true',
        'data-acsb-hidden': 'true',
        'data-acsb-force-hidden': 'true'
      });
    });
  }

  function normalizeHiddenFrames() {
    var selectors = [
      'iframe[data-product="web_widget"]',
      'iframe[name^="__privateStripeMetricsController"]',
      'iframe[id^="snap"]'
    ];

    applyToAll(selectors.join(','), function (element) {
      setAttrs(element, {
        role: 'presentation',
        tabindex: '-1',
        'aria-hidden': 'true',
        'data-acsb-hidden': 'true'
      });
    });
  }

  function normalizeSmileLauncher() {
    applyToAll('.smile-launcher-frame-container, .smile-launcher-frame', function (element) {
      if (!isVisible(element)) return;

      if (element.getAttribute('aria-hidden') === 'true') {
        element.removeAttribute('aria-hidden');
      }

      if (element.getAttribute('role') === 'presentation' || element.getAttribute('role') === 'none') {
        element.removeAttribute('role');
      }

      if (element.classList.contains('smile-launcher-frame') && element.getAttribute('tabindex') === '-1') {
        element.removeAttribute('tabindex');
      }

      if (element.tagName && element.tagName.toLowerCase() === 'iframe') {
        var title = element.getAttribute('title');
        var label = element.getAttribute('aria-label');
        if (!label && title) {
          setAttrs(element, { 'aria-label': title });
        }
      }
    });
  }

  function normalizeHiddenSlides() {
    applyToAll('.swiper-container .swiper-slide', function (slide) {
      var isActive = slide.classList.contains('swiper-slide-active') || slide.classList.contains('swiper-slide-visible');
      if (isActive) {
        if (slide.getAttribute('aria-hidden') === 'true') {
          slide.removeAttribute('aria-hidden');
        }
        if (slide.hasAttribute('data-acsb-hidden')) {
          slide.removeAttribute('data-acsb-hidden');
        }
      } else {
        setAttrs(slide, {
          'aria-hidden': 'true',
          'data-acsb-hidden': 'true'
        });
      }
    });
  }

  function normalizeAccessWidget() {
    applyToAll('access-widget-ui.notranslate', function (element) {
      setAttrs(element, { 'data-acsb': 'skipLinks' });
    });
  }

  function bindRoleButtonKeyboardSupport() {
    if (roleButtonKeyboardBound) return;
    roleButtonKeyboardBound = true;

    document.addEventListener('keydown', function (event) {
      if (event.defaultPrevented) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;

      var target = event.target;
      if (!target || !target.closest) return;

      var buttonLike = target.closest('[role="button"]');
      if (!buttonLike) return;
      if (buttonLike.getAttribute('aria-disabled') === 'true' || buttonLike.hasAttribute('disabled')) return;

      var tag = (buttonLike.tagName || '').toLowerCase();
      if (tag === 'button' || tag === 'summary' || tag === 'a') return;
      if (tag === 'input' && /^(button|submit|reset)$/i.test(buttonLike.type || '')) return;

      event.preventDefault();
      buttonLike.click();
    });
  }

  function applyRemediation() {
    normalizeNavigationLandmarks();
    normalizeCarousels();
    normalizeSwiperControls();
    normalizePseudoButtons();
    normalizeSearchLandmarks();
    normalizeLinks();
    normalizeFormFields();
    normalizeEmptyLists();
    normalizeHeadings();
    normalizeDecorativeElements();
    normalizeHiddenFrames();
    normalizeSmileLauncher();
    normalizeHiddenSlides();
    normalizeAccessWidget();
    bindRoleButtonKeyboardSupport();
  }

  var scheduled = false;
  function scheduleRemediation() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      applyRemediation();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRemediation);
  } else {
    scheduleRemediation();
  }

  new MutationObserver(scheduleRemediation).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
